var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 82,
    viewBox: "0 0 90 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 52.5842C90 53.4343 89.9629 54.2758 89.8903 55.1071L90 52.5842Z",
    fill: "url(#paint0_linear_126_987)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 52.5842C90 36.7812 77.1891 23.9702 61.386 23.9702C45.5829 23.9702 32.772 36.7812 32.772 52.5842C32.772 68.3873 45.5829 81.1982 61.386 81.1982C64.5882 81.1982 66.5231 81.024 69.3979 80.0537C79.9472 76.4929 88.8866 66.5973 89.8903 55.1071L90 52.5842Z",
    fill: "url(#paint1_linear_126_987)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3979 80.0537L88.495 78.9303C88.6997 78.9183 88.8622 78.7533 88.8711 78.5484L89.8903 55.1071C88.8866 66.5973 79.9472 76.4929 69.3979 80.0537Z",
    fill: "url(#paint2_linear_126_987)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_126_987)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7675 71.535C34.7049 71.535 33.6531 71.4887 32.614 71.3979L35.7675 71.535Z",
    fill: "url(#paint3_linear_126_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7675 71.535C55.5214 71.535 71.535 55.5214 71.535 35.7675C71.535 16.0137 55.5214 0 35.7675 0C16.0137 0 0 16.0137 0 35.7675C0 39.7703 0.217751 42.1889 1.4307 45.7824C5.88164 58.969 18.2512 70.1432 32.614 71.3979L35.7675 71.535Z",
    fill: "url(#paint4_linear_126_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4307 45.7824L2.8402 69.7439C2.85224 69.9486 3.01721 70.1111 3.22213 70.12L32.614 71.3979C18.2512 70.1432 5.88164 58.969 1.4307 45.7824Z",
    fill: "url(#paint5_linear_126_987)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_126_987)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.3145,
    cy: 36.483,
    r: 5.00745,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_126_987)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.6215,
    cy: 36.483,
    r: 5.00745,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_126_987)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.9285,
    cy: 36.483,
    r: 5.00745,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_126_987",
    x: 0,
    y: 0,
    width: 81.535,
    height: 79.5352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_126_987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_126_987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_126_987",
    x: 12.307,
    y: 29.4756,
    width: 18.0149,
    height: 18.0146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_126_987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_126_987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_126_987",
    x: 26.614,
    y: 29.4756,
    width: 18.0149,
    height: 18.0146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_126_987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_126_987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_126_987",
    x: 40.921,
    y: 29.4756,
    width: 18.0149,
    height: 18.0146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_126_987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_126_987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_987",
    x1: 40.7839,
    y1: 69.7526,
    x2: 83.1326,
    y2: 34.2713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FEFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397569,
    stopColor: "#8FEBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397669,
    stopColor: "#8FEBBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37DE87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_126_987",
    x1: 40.7839,
    y1: 69.7526,
    x2: 83.1326,
    y2: 34.2713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FEFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397569,
    stopColor: "#8FEBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397669,
    stopColor: "#8FEBBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37DE87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_126_987",
    x1: 40.7839,
    y1: 69.7526,
    x2: 83.1326,
    y2: 34.2713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FEFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397569,
    stopColor: "#8FEBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397669,
    stopColor: "#8FEBBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37DE87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_126_987",
    x1: 14.307,
    y1: 10.0149,
    x2: 58.6587,
    y2: 62.9508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#37C5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#1DB5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_126_987",
    x1: 14.307,
    y1: 10.0149,
    x2: 58.6587,
    y2: 62.9508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#37C5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#1DB5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_126_987",
    x1: 14.307,
    y1: 10.0149,
    x2: 58.6587,
    y2: 62.9508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#37C5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#1DB5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsLogo);
export default __webpack_public_path__ + "static/media/sms-logo.b8a616b65b4689fe79e1061d869275b6.svg";
export { ForwardRef as ReactComponent };